<template>
  <v-avatar
  :color="color"
  size="30"
>
<span v-if="user" class="user-initials  "  v-text="initials" style="color: var(--v-info-darken2);" ></span>
<img v-else src="/img/bot-white-full.png"  style="width: 20px;height: 20px;">

</v-avatar>
</template>

<script>
export default {
    props:['user'],
    data(){
        return {

        }
    },
computed:{
    initials() {
        if (this.user)
            return this.user.firstName.charAt(0) + this.user.lastName.charAt(0);
        else {
            return 'AI'
        }
    },
    color() {
        if (this.user)
            return 'var(--v-very_light_green-base)';
        else
         return 'var(--v-primary-darken2)';
    }
}
}
</script>

<style>

</style>